import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { ADMIN, COORDENADOR, SECRETARIA } from "../Usuario/Perfil";
import Container from "../UI/Container";
import ConfiguracaoInstituicaoContainer from "./Instituicao/ConfiguracaoInstituicaoContainer";
import ConfiguracaoInstituicaoProvidenceContainer from "./InstituicaoProvidence/ConfiguracaoInstituicaoProvidenceContainer";

const GERAL = "geral";
const PROVIDENCE = "providence";

export default function ConfiguracaoContainer() {
  const usuario = useSelector((state) => state.usuario);
  const [aba, setAba] = useState(GERAL);
  const podeVerProvidence = [ADMIN, COORDENADOR, SECRETARIA].includes(usuario.perfil);
  const abaAtiva = podeVerProvidence ? aba : GERAL;

  return (
    <Container>
      <Box mb={podeVerProvidence ? 1 : 3}>
        <Typography variant="h6">Configurações</Typography>
        <Typography variant="body2" color="text.secondary">
          Preferências da sua conta e da instituição.
        </Typography>
      </Box>

      {podeVerProvidence && (
        <Tabs
          value={abaAtiva}
          onChange={(event, value) => setAba(value)}
          sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
        >
          <Tab value={GERAL} label="Geral" />
          <Tab value={PROVIDENCE} label="Instituição Providence" />
        </Tabs>
      )}

      {abaAtiva === GERAL ? <ConfiguracaoInstituicaoContainer /> : <ConfiguracaoInstituicaoProvidenceContainer />}
    </Container>
  );
}
